import React, { useState } from "react";
import { Modal, Form, Row, Col, Input, Radio } from "antd";
import { eContent } from "../../constant/field-names";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";

export const CreateRecallModal = ({ dataSource, setDataSource }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();

    setDataSource([...dataSource, values]);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  return (
    <>
      <StyledButton bgColor="yellow" onClick={showModal} className="ml-1 mb-3">
        <div className="pb-1">Thêm mới</div>
      </StyledButton>

      <Modal
        title="TẠO CCDC CẦN THU HỒI"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <Col span={24}>
              <StyledTitle level={5}>
                Tên CCDC <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.toolName}
                rules={[{ required: true, message: "Nhập tên CCDC" }]}
              >
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <StyledTitle level={5}>
                Mã CCDC <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.toolId}
                rules={[{ required: true, message: "Nhập mã CCDC" }]}
              >
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>
                ĐVT <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.Dram}
                rules={[{ required: true, message: "Nhập ĐVT" }]}
              >
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>
                Số lượng <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.Quantity}
                rules={[
                  { required: true, message: "Nhập số lượng" },
                  {
                    message: "Giá trị không hợp lệ",
                    pattern: new RegExp(/^[1-9][0-9]*$/),
                  },
                ]}
              >
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>
                Lí do <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.reason}
                rules={[{ required: true, message: "Chọn lí do" }]}
              >
                <Radio.Group className="flex-center">
                  <Radio value={"Hư hỏng"}>Hư hỏng</Radio>
                  <Radio value={"Không có nhu cầu sử dụng"}>
                    Không có nhu cầu sử dụng
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
